export const ENV={
    NAME:process.env.REACT_APP_ENV,
    API_URL:process.env.REACT_APP_API_URL,
    API_KEY_URL:process.env.REACT_APP_KEY_URL,
    REALM: process.env.REACT_APP_REALM,
    BENEFICIARY_BASE_URL : process.env.REACT_APP_BENEFICIARY_BASE_URL,
    CLIENT : process.env.REACT_APP_CLIENT
}